import { Icon, IconProps } from "../";

export const MccmLineMenuIcon = (props: IconProps) => {
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 5.5C3 4.94772 3.44772 4.5 4 4.5H20C20.5523 4.5 21 4.94772 21 5.5C21 6.05228 20.5523 6.5 20 6.5H4C3.44772 6.5 3 6.05228 3 5.5ZM3 12C3 11.4477 3.44772 11 4 11H20C20.5523 11 21 11.4477 21 12C21 12.5523 20.5523 13 20 13H4C3.44772 13 3 12.5523 3 12ZM4 17.5C3.44772 17.5 3 17.9477 3 18.5C3 19.0523 3.44772 19.5 4 19.5H20C20.5523 19.5 21 19.0523 21 18.5C21 17.9477 20.5523 17.5 20 17.5H4Z"
      />
    </Icon>
  );
};
